import { FieldInput } from "@/components/form/field-input";

interface ProvinceFormFieldsProps {
  isDisabled?: boolean;
}

export function ProvinceFormFields({
  isDisabled = false,
}: ProvinceFormFieldsProps) {
  return (
    <>
      <FieldInput
        name="provinceName"
        label="Province Name"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldInput
        name="provinceCode"
        label="Province Code"
        isDisabled={isDisabled}
      />
    </>
  );
}
